import { render, staticRenderFns } from "./match-score-view.vue?vue&type=template&id=23f72985"
import script from "./match-score-view.vue?vue&type=script&lang=js"
export * from "./match-score-view.vue?vue&type=script&lang=js"
import style0 from "./match-score-view.vue?vue&type=style&index=0&id=23f72985&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports